export enum StringValidatorValidationType {
    EMAIL = 'EMAIL',
    REQUIRED = 'REQUIRED',
    NUMERIC = 'NUMERIC',
    IPV4 = 'IPV4',
    DOMAIN = 'DOMAIN',
    MAX_LENGTH = 'MAX_LENGTH',
    MIN_LENGTH = 'MIN_LENGTH',
    DATE = 'DATE',
    DATE_FUTURE = 'DATE_FUTURE',
}